import { useCallback, useMemo, useState } from "react";
import { nextSortState, sortRows, type SortDir, type SortState, type SortValue } from "../../sort.js";

export function useSort<T, K extends string>(
  rows: readonly T[],
  value: (row: T, key: K) => SortValue,
  initial: SortState<K>,
  initialDirs: Record<K, SortDir>,
) {
  const [sort, setSort] = useState<SortState<K>>(initial);
  const sorted = useMemo(() => sortRows(rows, value, sort), [rows, value, sort]);
  const onSort = useCallback(
    (key: K) => setSort((cur) => nextSortState(cur, key, initialDirs[key])),
    [initialDirs],
  );
  return { sorted, sort, onSort };
}
